import { useLocation } from 'react-router-dom';
import {
  PublicRoutes,
  RouterPaths,
} from '../../components/Router/Router.constants';
import { LayoutContext } from './Layout.context';
import useLayout from './Layout.hook';
import { tProvidersProps } from './Layout.types';
import PrivateLayout from './templates/Private.template';
import PublicLayout from './templates/Public.template';
import MessageNotification from '../../pages/Pipe/components/MessageNotification/MessageNotification.component';
import SyncProgressToastContainer from '../../components/SyncProgressToast/SyncProgressToastContainer.component';
import DevToolbar from '../../components/DevToolbar/DevToolbar.component';
import { IS_LOCAL_DEV } from '../../constants/envs';
import GlobalChatModal from '../../components/ChatModal/GlobalChatModal.component';

export const LayoutProvider = (props: tProvidersProps) => {
  const { children } = props;
  const location = useLocation();
  const isPublicRoute = PublicRoutes.includes(location.pathname);
  const html = document.documentElement;
  const layout = useLayout();

  // IS_LOCAL_DEV resolves to a literal boolean at build time, so Rollup can
  // tree-shake the DevToolbar module entirely from staging/production
  // bundles instead of relying on the component's internal `return null`
  // (which still ships the module code and runs hooks each layout mount).
  const isLocalDev = IS_LOCAL_DEV;

  if (isPublicRoute || location.pathname === RouterPaths.createWorkspace || location.pathname.startsWith(RouterPaths.onboarding)) {
    html.classList.add('page-public');

    return (
      <PublicLayout>
        {children}
        {isLocalDev && <DevToolbar />}
      </PublicLayout>
    );
  }

  html.removeAttribute('class');

  return (
    <LayoutContext.Provider value={layout}>
      <PrivateLayout>
        {layout.messageNotification ? <MessageNotification /> : null}
        <SyncProgressToastContainer />
        <GlobalChatModal />
        {children}
        {isLocalDev && <DevToolbar />}
      </PrivateLayout>
    </LayoutContext.Provider>
  );
};
